import { useEffect, useState } from 'react';

import detectStandaloneVisit from '@/utils/detectStandaloneVisit';

export default function useArtworkPageEnvironment() {
  const [isDirectAuctionEntry, setIsDirectAuctionEntry] = useState(false);
  const [isStandaloneVisit, setIsStandaloneVisit] = useState(() => detectStandaloneVisit());

  useEffect(() => {
    if (typeof document === 'undefined') {
      return;
    }

    const body = document.body;
    const browserClass = 'artwork-browser-visit';
    const standaloneClass = 'artwork-standalone-visit';

    if (isStandaloneVisit) {
      body.classList.add(standaloneClass);
      body.classList.remove(browserClass);
    } else {
      body.classList.add(browserClass);
      body.classList.remove(standaloneClass);
    }

    return () => {
      body.classList.remove(browserClass);
      body.classList.remove(standaloneClass);
    };
  }, [isStandaloneVisit]);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    const updateStandalone = () => {
      setIsStandaloneVisit(detectStandaloneVisit());
    };

    updateStandalone();

    if (typeof window.matchMedia !== 'function') {
      return;
    }

    const queries = ['(display-mode: standalone)', '(display-mode: fullscreen)', '(display-mode: minimal-ui)'];
    const listeners = [];

    queries.forEach((query) => {
      let mql;
      try {
        mql = window.matchMedia(query);
      } catch (_error) {
        mql = null;
      }
      if (!mql) {
        return;
      }
      const handler = () => updateStandalone();
      if (typeof mql.addEventListener === 'function') {
        mql.addEventListener('change', handler);
        listeners.push(() => mql.removeEventListener('change', handler));
      } else if (typeof mql.addListener === 'function') {
        mql.addListener(handler);
        listeners.push(() => mql.removeListener(handler));
      }
    });

    return () => {
      listeners.forEach((unsubscribe) => {
        try {
          unsubscribe();
        } catch (_error) {
          // no-op
        }
      });
    };
  }, []);

  useEffect(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') {
      return;
    }
    const referrer = document.referrer;
    if (!referrer) {
      setIsDirectAuctionEntry(true);
      return;
    }
    try {
      const origin = new URL(referrer).origin;
      setIsDirectAuctionEntry(origin !== window.location.origin);
    } catch (_error) {
      setIsDirectAuctionEntry(false);
    }
  }, []);

  return { isDirectAuctionEntry, isStandaloneVisit };
}
